import React from 'react';
import { addContentPath } from '../../util/pathUtil';
import Header from './Common/header';
import './css/index';

export default class Content_imgSlide extends React.Component {
    render() {
        const { data = {}, eid } = this.props;
        return (
            <div className="item" id={`item_${eid}`}>
                <Header ecId={`${this && this.props && this.props.ecId || ''}_Header@v3exj5`} data={data} eid={eid} />
                <div className="content" id={`content_${eid}`}>
                    <div className="content_view" id={`content_view_id_${eid}`}>
                        <div className={`content_${eid}`} style={{ width: '100%', height: '300px' }}>
                            <div className={`bannert_${eid}`} style={{ position: 'relative', width: '100%', height: '100%', overflow: 'hidden' }}>
                                <img src={addContentPath('/page/resource/userfile/image/elementPrew/imgSlide//MULTIpIC.png')} alt="" style={{ width: '100%', height: '300px' }} />
                                <ul className={'element_prew_ul'}>
                                    <li className={'element_prew_li on'} data-index="1" />
                                    <li className={'element_prew_li'} data-index="2" />
                                    <li className={'element_prew_li'} data-index="3" />
                                    <li className={'element_prew_li'} data-index="4" />
                                    <li className={'element_prew_li'} data-index="5" />
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}




// WEBPACK FOOTER //
// ../src4js/pc4mobx/portal4public/wea-element-preview/content/Content_imgSlide.js